import type { Locales } from 'cms/cms-types';
import { removeInvalidCharactersForSearch } from 'utils/string';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSearchWhereValue = (search = '', locale: Locales, ancestors?: string[]): any => {
    const languageLocale = locale.replace('_', '-');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ancestorsObj: any = (ancestors && ancestors.length > 0) ? {
        // since we're limiting for ancestor, we also need to specify content type pdf to make sure we can get PDF file result that's not in tree
        _or: [
            { Ancestors: { in: ancestors } },
            { ContentType: { in: ['PdfFile'] } }
        ],
    } : {};

    const cleanedSearch = removeInvalidCharactersForSearch(search).trim();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const whereObj: any = {
        _and: [
            ...(ancestorsObj ? [ancestorsObj] : []),
            {
                _or: [
                    ...(cleanedSearch.length > 1 ? [
                        {
                            _fulltext: {
                                like: `%${search.trim()}%`,
                                // boost: 150,
                            },
                        }, {
                            Name: {
                                like: `%${search.trim()}%`,
                                boost: 25,
                            },
                        }
                    ] : []),
                    {
                        _fulltext: {
                            match: `${search.trim()}`,
                            // boost: 150,
                        },
                    }, {
                        Name: {
                            match: `${search.trim()}`,
                            boost: 15,
                        },
                    }
                ],
            },
            // {
            //     _or: [
            //         {
            //             ContentType: {
            //                 eq: 'StandardPage',
            //                 boost: 20,
            //             },
            //         },
            //         {
            //             ContentType: {
            //                 eq: 'ArticlePage',
            //                 boost: 20,
            //             },
            //         },
            //         {
            //             ContentType: {
            //                 eq: 'LocationPage',
            //                 boost: 20,
            //             },
            //         },
            //         {
            //             ContentType: {
            //                 eq: 'PersonPage',
            //                 boost: 20,
            //             },
            //         },
            //         {
            //             ContentType: {
            //                 eq: 'PdfFile',
            //                 boost: 15,
            //             },
            //         }
            //     ],
            // },
            {
                _or: [
                    { ExistingLanguages: { Name: { in: [languageLocale] } } },
                    { Language: { Name: { eq: languageLocale } } }
                ],
            },
            // { _not: [{ ContentType: { in: ['SearchPage', 'NotFoundPage'] } }] },
            { ExcludeFromSearch: { eq: false } },
            { Status: { in: 'Published' } }
        ],
    };

    return whereObj;
};
